export default __webpack_public_path__ + "static/media/cst.8fe46754.png";